import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  async submitForm(event) {
    event.preventDefault(); // Prevent default form submission

    const form = event.target;
    const formData = new FormData(form);
    
    try {
      const response = await fetch(form.action, {
        method: form.method,
        body: formData,
        headers: {
          "X-Requested-With": "XMLHttpRequest" // Rails detects AJAX request
        }
      });

      if (response.ok) {
        const jsonResponse = await response.json();
        alert("Payment Successful!"); // You can update UI instead
      } else {
        alert("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred. Please try again.");
    }
  }
}
